// jQuery
jQuery(function ($) {
  // -----------------------------
  // メガメニュー
  // -----------------------------
  if (window.matchMedia("(min-width: 920px)").matches) {
    $(".gnavMain-item").mouseover(function () {
      $(".gnavChild-wrap").addClass("is-open");
    });
    $(".gnavMain-item").mouseout(function () {
      $(".gnavChild-wrap").removeClass("is-open");
    });
  }

  if (window.matchMedia("(max-width: 919px)").matches) {
    $(".gnavMain-item").click(function () {
      $(this).find(".gnavChild-wrap").slideToggle();
      $(this).toggleClass("is-open");
      $(this).parents(".gnavMain-item").toggleClass("is-open");
    });
  }

  // -----------------------------
  // ハンバーガーメニュー
  // -----------------------------
  $(".gnavBtn").on("click", function () {
    $(this).toggleClass("is-open");
    $(".gnav").toggleClass("is-open");
    var expanded = $(this).attr("aria-expanded") === "true";
    $(this).attr("aria-expanded", !expanded);
    var label = $(this).attr("aria-label") === "メニューを開く" ? "メニューを閉じる" : "メニューを開く";
    $(this).attr("aria-label", label);
    var hidden = $(".gnav").attr("aria-hidden") === "true";
    $(".gnav").attr("aria-hidden", !hidden);
  });

  $(".gnav a").on("click", function () {
    $(".gnav").removeClass("is-open");
    $(".gnavBtn").removeClass("is-open");
    $(".gnavBtn").attr("aria-expanded", "false");
    $(".gnavBtn").attr("aria-label", "メニューを開く");
    $(".gnav").attr("aria-hidden", "true");
  });

  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $(".totop");

  topBtn.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      300,
      "swing"
    );
    return false;
  });

  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $(".totop");

  topBtn.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      300,
      "swing"
    );
    return false;
  });
});

// -----------------------------
// officer-introduction 略歴を見る
// -----------------------------

jQuery(".btnArrow.officer-btn").click(function () {
  $id = jQuery(this).attr("href");

  // ボタンの動作
  jQuery(".btnArrow.officer-btn").removeClass("is-active");
  jQuery(this).addClass("is-active");

  // クリックしたボタンに該当するID
  $infoWrap = jQuery($id);
  // ボタンに該当するIDの親要素
  $infoGroup = jQuery($id).parent(".officer-infoGroup");

  // 開いている略歴を閉じる場合
  if ($infoGroup.hasClass("is-active") && $infoWrap.hasClass("is-active")) {
    // 開いている略歴を閉じる
    $infoGroup.slideUp().removeClass("is-active");
    if (jQuery(this).hasClass("is-active")) {
      jQuery(this).removeClass("is-active");
    }

    // 同じグループの略歴を切り替える場合
  } else if ($infoGroup.hasClass("is-active")) {
    // 該当するIDと関連する略歴を非表示
    $infoGroup.find(".officer-infoWrap").removeClass("is-active");
    // 該当するIDにクラス付与（表示）
    $infoWrap.addClass("is-active");

    // 別のグループが開いている場合
  } else if (jQuery(".officer-infoGroup").hasClass("is-active")) {
    // 別のグル―プ非表示
    jQuery(".officer-infoGroup").slideUp().removeClass("is-active");
    $infoGroup.find(".officer-infoWrap").removeClass("is-active");
    // 該当するIDにクラス付与（表示）
    $infoWrap.addClass("is-active");
    // 親要素を表示・クラス付与
    $infoGroup.slideDown().addClass("is-active");

    // 全て開いてない場合
  } else {
    // 該当するIDと関連する情報を非表示
    jQuery(".officer-infoWrap").removeClass("is-active");
    // 該当するIDにクラス付与（表示）
    $infoWrap.addClass("is-active");
    // 親要素を表示・クラス付与
    $infoGroup.slideDown().addClass("is-active");
  }

  return false;
});

// -----------------------------
// keywords切替用
// -----------------------------

jQuery(document).ready(function () {
  // ボタンクリック時のイベント
  jQuery('[id^="js-open-"]').on("click", function () {
    // すべての要素から is-active クラスを削除
    jQuery(".target, .keywordsList-item").removeClass("is-active");
    jQuery(this).addClass("is-active");

    // クリックされたボタンのIDから 'js-open-' 部分を取り外してクラス名を取得
    let targetClass = jQuery(this).attr("id").replace("js-open-", "");
    // 対応するクラスに is-active を追加
    setTimeout(function () {
      jQuery("." + targetClass).addClass("is-active");
    }, 50);
  });
});

// -----------------------------
// アコーディオン開閉用
// -----------------------------
jQuery(document).ready(function () {
  jQuery(".accordion").each(function () {
    const $el = jQuery(this);
    const $summary = $el.find(".accordion-ttl");
    const $answer = $el.find(".accordion-contents");

    $summary.on("click", function (event) {
      // デフォルトの挙動を無効化
      event.preventDefault();

      if ($el.attr("open") !== undefined) {
        // アコーディオンを閉じるときの処理
        $answer.stop().animate(
          {
            height: 0,
            opacity: 0,
          },
          animTiming.duration,
          animTiming.easing,
          function () {
            // アニメーションの完了後にopen属性を取り除く
            $el.removeAttr("open");
          }
        );
      } else {
        // open属性を付与
        $el.attr("open", true);
        // 一旦高さを自動に設定して、自然な高さを取得
        $answer.css({
          height: "auto",
          opacity: 0,
        });

        const fullHeight = $answer.outerHeight();

        // 高さを0にリセットし、アニメーションを開始
        $answer
          .css({
            height: 0,
            opacity: 0,
          })
          .stop()
          .animate(
            {
              height: fullHeight,
              opacity: 1,
            },
            animTiming.duration,
            animTiming.easing
          );
      }
    });
  });
});

// アニメーションの時間とイージング
const animTiming = {
  duration: 400,
  easing: "swing", // jQueryのデフォルトのイージングに設定
};

// -----------------------------
// スライダー(swiper)
// -----------------------------
const swiper = new Swiper(".snblers-slider", {
  // ループするか否か
  loop: true,
  speed: 700,
  // 自動再生
  autoplay: {
    // 一度のスライドの表示時間
    delay: 5000,
    // マウスオーバー時に自動再生を停止するか
    disableOnInteraction: false,
  },

  // 左右のボタン。疑似要素で記号は実装しているので、変更する場合は疑似要素をdisplay: none;で非表示にする
  navigation: {
    nextEl: ".snblers-slider-next",
    prevEl: ".snblers-slider-prev",
  },

  // スライド間の隙間
  spaceBetween: 14,

  // 一覧で表示するスライドの枚数
  slidesPerView: "auto",

  // センタリング
  centeredSlides: true,

  // レスポンシブブレイクポイント
  breakpoints: {
    920: {
      centeredSlides: false,
    },
  },
});

// -----------------------------
// コンタクトフォームの選択肢によって表示を切り替える
// -----------------------------
jQuery(document).ready(function () {
  // デフォルトは事業についてが選択されているため表示
  jQuery(".hidden-menu").fadeIn(120); // 表示

  jQuery('input[name="your-subject"]').on("change", function () {
    if (jQuery(this).val() === "事業について") {
      jQuery(".hidden-menu, .hidden-text").hide(); // 非表示
      jQuery(".hidden-menu").fadeIn(120); // 表示
    } else if (jQuery(this).val() === "IR広報関連") {
      jQuery(".hidden-menu, .hidden-text").hide(); // 非表示
      jQuery(".hidden-text").fadeIn(120); // 表示
    } else {
      jQuery(".hidden-menu, .hidden-text").hide(); // 非表示
    }
  });
});

// -----------------------------
// コンタクトフォームの確認・完了画面への遷移
// -----------------------------

jQuery(document).ready(function () {
  // 入力内容を格納するための変数
  // 入力フィールドのタイプを格納するための変数
  let type;
  // ラジオボタンの選択値を格納するための変数
  let radio;
  // チェックボックスの選択値を格納するための変数
  let check;

  // ラジオボタンの初期値を取得し、確認画面に反映させる
  jQuery('[type="radio"]:checked').each(function () {
    // ラジオボタンの選択値を取得
    radio = jQuery(this).val();
    // ラジオボタンの親要素からidを取得
    const id = jQuery(this).closest("[id]").attr("id");
    // 取得したidをクラス名に追加し、確認画面の値を設定
    jQuery(".confirm-" + id).text(radio);
  });

  // 入力フィールドの内容が変更された場合の処理
  jQuery(".contactForm-item input, .contactForm-item select, .contactForm-item textarea").on("change", function () {
    // 入力内容を取得
    val = jQuery(this).val();
    // 入力フィールドのタイプを取得
    type = jQuery(this).attr("type");
    // ラジオボタンの場合の処理
    if (type === "radio") {
      // ラジオボタンの選択値を取得
      radio = jQuery(this).val();
      // ラジオボタンの親要素からidを取得
      const id = jQuery(this).closest("[id]").attr("id");
      // 取得したidをクラス名に追加し、確認画面の値を設定
      jQuery(".confirm-" + id).text(radio);
    }
    // チェックボックスの場合の処理
    else if (type === "checkbox") {
      // チェックボックスの選択値を取得
      check = jQuery(this).val();
      // チェックボックスの親要素からidを取得
      const id = jQuery(this).closest("[id]").attr("id");
      // 取得したidをクラス名に追加し、確認画面の値を設定
      jQuery(".confirm-" + id).append(check + " / ");
    }
    // 特定のtextareaの処理 (confirm-your-message の id を持つ場合)
    else if (jQuery(this).is("textarea")) {
      const id = jQuery(this).attr("id");
      // 改行を <br> に置き換えた値を取得
      let message = jQuery(this).val().replace(/\n/g, "<br>");
      // 変換後の値を確認画面の指定箇所に設定
      jQuery(".confirm-" + id).html(message); // .confirm-your-message に表示
    }
    // その他の場合の処理
    else {
      // 入力フィールドのidを取得
      const id = jQuery(this).attr("id");
      // 取得したidをクラス名に追加し、確認画面の値を設定
      jQuery(".confirm-" + id).text(val);
    }
  });

  // 確認ボタンをクリックした場合の処理
  jQuery(".confirm-button").on("click", function (e) {
    e.preventDefault();
    jQuery(".wpcf7-form-control-wrap").show();
    jQuery(".contact-faq").hide();
    jQuery(".contactSection").hide();
    jQuery(".contactForm-area").hide();
    jQuery(".confirm-area").show();
    jQuery(".contact-breadcrumb, .confirm-breadcrumb").toggleClass("hidden-breadcrumb");
    jQuery("html, body").animate(
      {
        scrollTop: jQuery("#top").offset().top,
      },
      400
    );
  });

  // 戻るボタンをクリックした場合の処理
  jQuery(".back-btn").on("click", function (e) {
    e.preventDefault();
    jQuery(".contact-faq").show();
    jQuery(".contactSection").show();
    jQuery(".contactForm-area").show();
    jQuery(".confirm-area").hide();
    jQuery(".contact-breadcrumb, .confirm-breadcrumb").toggleClass("hidden-breadcrumb");
    jQuery("html, body").animate(
      {
        scrollTop: jQuery("#contactSection").offset().top,
      },
      400
    );
  });

  // 必須項目が変更された場合の処理
  const requiredInputs = jQuery('[aria-required="true"]');
  const yourEmail = jQuery("#your-email");
  const privacyPolicyCheckbox = jQuery("#privacy-policy");

  requiredInputs.on("input", function () {
    checkFormValidity();
  });

  yourEmail.on("input", function () {
    checkFormValidity();
  });

  privacyPolicyCheckbox.on("change", function () {
    checkFormValidity();
  });

  function checkFormValidity() {
    // フラグを全項目が埋まっている状態に初期化
    let isValid = true;

    // 必須項目をループで確認
    requiredInputs.each(function () {
      if (jQuery(this).val() === "") {
        isValid = false;
      }
    });

    // メールアドレスのバリデーション: 正しい形式のメールアドレスかどうか
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(yourEmail.val()) || yourEmail.val() === "") {
      isValid = false;
    }

    // プライバシーポリシーがチェックされているかどうか
    if (!privacyPolicyCheckbox.is(":checked")) {
      isValid = false;
    }

    // フォーム全体が有効かどうかによってボタンのクラスを切り替える
    if (isValid) {
      jQuery(".confirm-button").removeClass("disabled");
    } else {
      jQuery(".confirm-button").addClass("disabled");
    }
  }

  // 送信ボタンをクリックした場合の処理
  if (location.pathname === "/snbl/research-funding") {
    jQuery(document).on("wpcf7mailsent", function () {
      window.location.href = "./research-funding/thanks_rf/";
    });
  } else if (location.pathname === "/snbl/contact") {
    jQuery(document).on("wpcf7mailsent", function () {
      window.location.href = "./contact/thanks/";
    });
  }
});

// -----------------------------
// keywordページの表示切替
// -----------------------------

window.onload = function () {
  const urlParams = new URLSearchParams(window.location.search);
  const buttonKey = urlParams.get("button");

  const buttonMap = {
    industryLeader: "js-open-industryLeader",
    global: "js-open-global",
    specialists: "js-open-specialists",
    womanActivities: "js-open-womanActivities",
    challenger: "js-open-challenger",
  };

  const buttonId = buttonMap[buttonKey];

  if (buttonId) {
    const button = document.getElementById(buttonId);
    if (button) {
      button.click(); // ボタンをクリックして表示を切り替える
    }
  }
};

// -----------------------------
// 決済公告の表示切り替え
// -----------------------------

// ページが読み込まれたときに実行される関数
jQuery(".js-open-btn").on("click", function (e) {
  e.preventDefault(); // デフォルト動作を防ぐ

  // id取得
  const financialResultsID = "#" + jQuery(this).children("a").attr("href");

  // 決済公告の表示非表示
  jQuery(".publish-financialResults").removeClass("is-active");
  jQuery(financialResultsID).addClass("is-active");
  // メニューの文字色変更
  jQuery(".js-open-btn").removeClass("is-active");
  jQuery(this).addClass("is-active");
});

// 最初から開いているものにis-active付与
jQuery(document).ready(function () {
  jQuery(".js-open-btn").first().addClass("is-active");
});
